export const translationLocations: string[] = [
  'assets/i18n/dashboard/',
  'assets/i18n/case-management/',
  'assets/i18n/working-groups/',
  'assets/i18n/users/',
  'assets/i18n/fiu-management/',
  'assets/i18n/shared/'
]

export const languageList = [
  { code: 'en-GB', label: 'English', icon: 'assets/images/languages/en-GB.png' },
  { code: 'de-DE', label: 'Deutsch', icon: 'assets/images/languages/de-DE.png' },
];

export const defaultLanguage = 'en-GB';
export const agTheme = 'ag-theme-quartz';
